import createAlert from "./create";
import deleteAlert from "./delete";
import updateAlert from "./update";

const alertReducer = {
  createAlert,
  deleteAlert,
  updateAlert,
};

export default alertReducer;
